export const environment = {
  production: true,
  apiUrl: 'https://nightkeyapi2-master.azurewebsites.net/api'  
};



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/environments/environment.ts